import { AnyAction } from 'redux';
import { FilterGroup } from '../Components/ProductFiltering/types/FilterGroup';
import { SelectListItem } from '../Components/ProductListing/types/SelectListItem';
import { SortCriteriaState } from '../Components/ProductSorting/types/SortCriteriaState';
import {
  PRODUCT_FILTERING_RECEIVE,
  PRODUCT_FILTERING_SET_SORTING,
  PRODUCT_FILTERING_UPDATE_FILTERS,
  UPDATE_CATEGORY_DESCRIPTION,
} from '../constants';

export interface ProductFilteringState {
  subNavigation: any;
  sortCriteria?: SortCriteriaState;
  productsPerLoadDropdownValues?: SelectListItem[];
  filters: FilterGroup[];
  navigationTheme: string;
  currentCategoryDescription: string;
}

const defaultState: ProductFilteringState = {
  subNavigation: null,
  sortCriteria: undefined,
  filters: [],
  navigationTheme: 'filter',
  currentCategoryDescription: '',
};

export default (
  state = defaultState,
  action: AnyAction
): ProductFilteringState => {
  const { type, payload } = action;
  switch (type) {
    case PRODUCT_FILTERING_RECEIVE:
      return {
        ...state,
        ...payload,
      };
    case PRODUCT_FILTERING_SET_SORTING:
      const newState = { ...state };
      if (newState.sortCriteria) {
        const currentlySelectedItem = newState.sortCriteria.sortItems.find(
          (s) => s.selected
        );

        // Unset currently selected item
        if (currentlySelectedItem) {
          currentlySelectedItem.selected = false;
        }

        // Find the selected item and set it as selected
        const sortItemIndex = newState.sortCriteria.sortItems.indexOf(payload);
        if (sortItemIndex != -1) {
          newState.sortCriteria.sortItems[sortItemIndex].selected = true;
        }
      }
      return {
        ...newState,
      };
    case PRODUCT_FILTERING_UPDATE_FILTERS:
      return {
        ...state,
        filters: payload,
      };
    case UPDATE_CATEGORY_DESCRIPTION: {
      return {
        ...state,
        currentCategoryDescription: payload.description ?? '',
      };
    }
    default:
      return state;
  }
};
